import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";

function AllSavedTemplates() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.letterGenerate === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [templateData, setTemplateData] = useState([]);

  // fetch all templates
  async function getTemplates() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/template/get/all`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTemplateData(res.data?.data || []);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Templates fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // delete template
  async function deleteTemplate(templateId) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/template/delete/${templateId}`,
        method: "delete",
        withCredentials: true,
      });
      setReload((prev) => !prev);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Template delete failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getTemplates();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            All Templates
          </h1>
          <div className="w-full mt-5">
            <section className="my-5 flex justify-end">
                <ButtonCompo variant="contained" href="/admin/letter/template/add">
                    Add Template
                </ButtonCompo>
            </section>
            <Table>
              <TableHead>
                <TableRow className="!bg-blue-500">
                  <TableCell className="!text-center !text-white">
                    SL No
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Template
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Created At
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Sender
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Sender Designation
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Edit
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="border">
                {templateData.map((data, i) => (
                  <TableRow>
                    <TableCell className="!text-center">{i + 1}</TableCell>
                    <TableCell className="!text-center">
                      {data?.title}
                    </TableCell>
                    <TableCell className="!text-center">
                      {new Date(data?.createdAt).toLocaleDateString("en-IN")}
                    </TableCell>
                    <TableCell className="!text-center">
                      {data?.sender}
                    </TableCell>
                    <TableCell className="!text-center">
                      {data?.senderDesignation}
                    </TableCell>
                    <TableCell className="!text-center">
                      <ButtonCompo
                        href={`/admin/letter/template/edit/${data?._id}`}
                      >
                        Edit
                      </ButtonCompo>
                    </TableCell>
                    <TableCell className="!text-center">
                      <ButtonCompo color="error" onClick={() => deleteTemplate(data?._id)}>
                        Delete
                      </ButtonCompo>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllSavedTemplates;
